import {
  Button,
  Col,
  Dropdown,
  Input,
  Menu,
  message,
  Modal,
  Popover,
  Row,
  Space,
} from "antd";
import Text from "antd/lib/typography/Text";
import moment from "moment";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import BillActive from "../../assets/icons/bill_active.png";
import BillInactive from "../../assets/icons/bill_inactive.png";
import CommentInactive from "../../assets/icons/comment.png";
import CommentActive from "../../assets/icons/comment_active.png";
import DropdownIcon from "../../assets/icons/dropdown_icon.png";
import ErrorActive from "../../assets/icons/error_active.png";
import ErrorInactive from "../../assets/icons/error_inactive.png";
import warn from "../../assets/icons/warning.png";
import { millify } from "../../config/helper";
import { objectToFormData } from "../../utils";
import TableWrap from "../Common/Table/Table";
import "./report.css";

import {
  reportsExpAddComments,
  ReportsExpComments,
  reportsExpComments,
  TransactionsPartialApprove,
  transactionsPartialApprove,
  TransactionsReject,
  transactionsReject,
} from "../../actions/reports";
import BaseCurrency from "../Common/BaseCurrency";
import {
  DeleteExpense,
  expenses_delete,
} from "../../actions/expenses/expenses";

const { TextArea } = Input;

// const content = (
//   <div>
//     <Row>
//       <Col span={10}>
//         <Button danger className="policyVoiButton">
//           Warning
//         </Button>
//       </Col>
//       <Col span={14}>
//         Cash amount should not exceed than Rs. 1000 per quarter
//       </Col>
//     </Row>
//     <hr className="mt1 mb1" />
//     <Row>
//       <Col span={10}>
//         <Button danger className="policyVoiButton">
//           Warning
//         </Button>
//       </Col>
//       <Col span={14}>
//         Cash amount should not exceed than Rs. 1000 per quarter
//       </Col>
//     </Row>
//   </div>
// );

message.config({
  maxCount: 3,
});

const formatCommentTimestamp = (createdAt) => {
  if (!createdAt) {
    return "-";
  }

  const parsedDate = moment(
    createdAt,
    [
      "DD-MM-YYYY,HH:mm:ss",
      "DD-MM-YYYY, HH:mm:ss",
      "DD-MM-YYYY HH:mm:ss",
      "YYYY-MM-DD HH:mm:ss",
      moment.ISO_8601,
    ],
    true,
  );

  if (parsedDate.isValid()) {
    return parsedDate.format("DD-MM-YYYY, HH:mm:ss");
  }

  const fallbackDate = moment(createdAt);
  return fallbackDate.isValid()
    ? fallbackDate.format("DD-MM-YYYY, HH:mm:ss")
    : createdAt;
};

const Expenses = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const is_admin = useSelector(
    (state) => state?.auth?.localVariables?.is_admin,
  );

  const inputComment = React.useRef(null);
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [modalType, setModalType] = React.useState("");
  const [reasonValue, setReasonValue] = React.useState("");
  const [amountValue, setAmountValue] = React.useState("");
  const [input, setInput] = React.useState("");
  const { expensesData } = props;
  const [expenseSelectedData, setExpensesSelectedData] = React.useState("");
  const [filesPopup, setFilesPopup] = React.useState(false);
  const [billFiles, setBillFiles] = React.useState([]);

  const reportsExpCommentsResponse = useSelector(
    (state) => state.reports.reportsExpComments || {},
  );
  const reportsExpAddCommentsResponse = useSelector(
    (state) => state.reports.reportsExpAddComments || {},
  );
  const transactionsRejectResponse = useSelector(
    (state) => state.reports.transactionsReject || {},
  );
  const deleteExpResponse = useSelector(
    (state) => state.reports.deleteExpense || {},
  );
  const transactionsPartialApproveResponse = useSelector(
    (state) => state.reports.transactionsPartialApprove || {},
  );

  React.useEffect(() => {
    expensesData?.forEach((ele) => {
      dispatch(reportsExpComments({ transaction_id: ele.id }));
    });
    return () => {
      dispatch({
        type: ReportsExpComments.RESET,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expensesData]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      reportsExpAddCommentsResponse;
    if (status && expenseSelectedData) {
      dispatch(reportsExpComments({ transaction_id: expenseSelectedData }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reportsExpAddCommentsResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      transactionsRejectResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch({
        type: TransactionsReject.RESET,
      });
      props.callExpenseDetails();
    } else {
      if (res_message) {
        dispatch({
          type: TransactionsReject.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionsRejectResponse]);
  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      deleteExpResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch({
        type: DeleteExpense.RESET,
      });
      props.callExpenseDetails();
    } else {
      if (res_message) {
        dispatch({
          type: DeleteExpense.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteExpResponse]);

  React.useEffect(() => {
    const { data: { message: res_message = "", status = false } = {} } =
      transactionsPartialApproveResponse;
    if (status) {
      setIsModalVisible(false);
      dispatch({
        type: TransactionsPartialApprove.RESET,
      });
    } else {
      if (res_message) {
        dispatch({
          type: TransactionsPartialApprove.RESET,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionsPartialApproveResponse]);

  const handleAddComment = (record) => {
    if (input?.trim() && record.id) {
      dispatch(
        reportsExpAddComments(
          objectToFormData({
            body: input,
            transaction_id: record.id,
          }),
        ),
      );
      setInput("");
    }
  };

  const expenseError = (record) => {
    let arr = [];
    record?.expense_errors?.expense?.forEach((ele) =>
      ele?.policies?.forEach((itm) =>
        itm.errors?.forEach((item) => arr.push(item)),
      ),
    );
    return arr?.length;
  };

  const columns = [
    {
      title: "Ex ID",
      dataIndex: "transaction_number",
      key: "transaction_number",
    },
    {
      title: "Date - Time",
      dataIndex: "created_at",
      key: "created_at",
    },
    {
      title: "Merchant",
      dataIndex: "merchant_name",
      key: "merchant_name",
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
    },
    {
      title: "Payment Mode",
      dataIndex: "payment_method",
      key: "payment_method",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => (
        <>
          <BaseCurrency /> {millify(text)}
        </>
      ),
    },
    {
      title: "",
      dataIndex: "id",
      key: "id",
      render: (text, record) => {
        return (
          <Space
            key={record.id}
            size="middle"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
          <div
              className="imgWrapper"
              style={{
                "--bg-color": record?.files?.length > 0 ? "#E1F8D9" : "#F7F7F7",
              }}
              onClick={() => {
                if (record?.files?.length > 0) {
                  setFilesPopup(true);
                  setBillFiles(record.files);
                }
              }}
            >
              {record?.files?.length > 0 && (
                <span style={{ "--color": "#49B928" }}>
                  {record.files.length}
                </span>
              )}
              <img
                src={record?.files?.length > 0 ? BillActive : BillInactive}
                alt="logo"
                className="action-logo"
              />
            </div>
            <Popover
              placement="bottom"
              title="Expense Errors"
              content={
                <section className="report-error p1">
                  {expenseError(record) > 0
                    ? record?.expense_errors?.expense?.map((ele) => (
                        <>
                          <p>{ele.transaction_number}</p>

                          {ele?.policies?.map((itm) => (
                            <p
                              className={`item ${itm.is_warning ? "warn" : ""}`}
                            >
                              {itm?.errors?.map((item) => (
                                <>
                                  {" "}
                                  <img
                                    src={itm.is_warning ? warn : ErrorActive}
                                    alt=""
                                    width={12}
                                    className="mr1"
                                  />{" "}
                                  {item}
                                  <br />
                                </>
                              ))}
                            </p>
                          ))}
                        </>
                      ))
                    : "No Data"}
                </section>
              }
              trigger="click"
            >
              <div
                className="imgWrapper"
                style={{
                  "--bg-color": false ? "#FCE7E7" : "#F7F7F7",
                }}
              >
                {expenseError(record) > 0 && (
                  <span
                    style={{
                      "--color": "#E24C4B",
                    }}
                  >
                    {expenseError(record)}
                  </span>
                )}
                <img
                  src={expenseError(record) ? ErrorActive : ErrorInactive}
                  alt={"logo"}
                  className="action-logo"
                />
              </div>
            </Popover>
            <Popover
              placement="bottom"
              title="Comments"
              content={commentsContent(record)}
              trigger="click"
            >
              <div
                className="imgWrapper"
                style={{
                  "--bg-color": reportsExpCommentsResponse?.[record?.id]
                    ?.response?.comments.length
                    ? "#F0F4FC"
                    : "#F7F7F7",
                }}
                onClick={() => handleExpComments(text)}
              >
                {reportsExpCommentsResponse?.[record?.id]?.response?.comments
                  ?.length ? (
                  <span
                    style={{
                      "--color": "#5A87F9",
                    }}
                  >
                    {
                      reportsExpCommentsResponse?.[record?.id]?.response
                        ?.comments?.length
                    }
                  </span>
                ) : null}
                <img
                  src={
                    reportsExpCommentsResponse?.[record?.id]?.response?.comments
                      ?.length
                      ? CommentActive
                      : CommentInactive
                  }
                  alt={"logo"}
                  className="action-logo"
                />
              </div>
            </Popover>
            <Dropdown overlay={menu(record)} placement="bottomRight">
              <img src={DropdownIcon} alt={"logo"} className="action-logo" />
            </Dropdown>
          </Space>
        );
      },
    },
  ];

  const commentsContent = (record) => (
    <div>
      <Row>
        <Col span={24} className="commentsContent">
          {reportsExpCommentsResponse?.[record?.id]?.response?.comments
            ?.length ? (
            reportsExpCommentsResponse?.[record?.id]?.response?.comments?.map(
              (item) => (
                <>
                  <p key={item.id} className="commentBody">
                    {item.body}
                  </p>
                  <span className="commentData">
                    {formatCommentTimestamp(item.created_at)} |{" "}
                    {item.user_name}
                  </span>
                  <hr className="mt1 mb1" />
                </>
              ),
            )
          ) : (
            <p style={{ color: "#333" }}>No Comments</p>
          )}
        </Col>
      </Row>
      <Row>
        <div className="addExpComment mt2">
          <Input
            placeholder="Enter Comment"
            ref={inputComment}
            value={input}
            onInput={(e) => setInput(e.target.value.trimStart())}
          />
          <Button
            key="1"
            className="formButton ml1"
            onClick={() => handleAddComment(record)}
          >
            Send
          </Button>
        </div>
      </Row>
    </div>
  );

  function handleMenuClick(e, record) {
    switch (e.key) {
      case "1":
        history.push({
          pathname: `/expense-details/${record.id}`,
          state: { expenseData: { ...record, isFromExpense: false } },
        });
        break;
      case "2":
        setReasonValue("");
        setIsModalVisible(true);
        setModalType("delete");
        setExpensesSelectedData(record.id);
        break;
      case "3":
        setAmountValue("");
        setIsModalVisible(true);
        setModalType("partial");
        setExpensesSelectedData(record.id);
        break;
      case "4":
        setReasonValue("");
        setIsModalVisible(true);
        setModalType("deleteExp");
        setExpensesSelectedData(record.id);
        break;
      default:
    }
  }

  const menu = (record) => (
    <Menu onClick={(e) => handleMenuClick(e, record)}>
      <Menu.Item key="1">View Expense</Menu.Item>
      {props.showReject && (
        <>
          {is_admin && !props.isLastExpense && (
            <Menu.Item key="2">Reject Expense</Menu.Item>
          )}
          {/* {is_admin && <Menu.Item key="3">Partial Approval</Menu.Item>} */}
        </>
      )}
      {props.showDelete && <Menu.Item key="4">Unlink Expense</Menu.Item>}
    </Menu>
  );

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleExpComments = (id) => {
    setExpensesSelectedData(id);
    dispatch(reportsExpComments({ transaction_id: id }));
  };

  const renderDeleteOption = () => {
    return (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(
            transactionsReject(
              objectToFormData({
                id: expenseSelectedData,
                reason: reasonValue,
              }),
            ),
          );
        }}
      >
        <Text>Please specify an appropriate reason for rejection.</Text>
        <br />
        <TextArea
          rows={4}
          placeholder="Enter Reason"
          className="reasonTextArea"
          value={reasonValue}
          required={true}
          onChange={(e) => setReasonValue(e.target.value)}
        />
        <br />
        <Button
          key="1"
          htmlType="submit"
          className="formButton mt1"
          disabled={!reasonValue || transactionsRejectResponse?.loading}
        >
          Confirm
        </Button>
        <Button
          key="2"
          htmlType="button"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </form>
    );
  };

  const renderDelete = () => {
    return (
      <>
        <Text>Are you sure you want to unlink expense from this report.</Text>
        <br />
        <Button
          key="1"
          className="formButton mt1"
          disabled={deleteExpResponse?.loading}
          onClick={() => {
            dispatch(
              expenses_delete({
                transactions: [expenseSelectedData],
                unlink: true,
              }),
            );
          }}
        >
          Unlink
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  const renderPartialAcceptOption = () => {
    return (
      <>
        <Text>Please specify amount for Partial Approval.</Text>
        <br />
        <br />
        <Input
          placeholder="Enter Amount"
          value={amountValue}
          onChange={(e) => setAmountValue(e.target.value)}
        />
        <br />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() =>
            dispatch(
              transactionsPartialApprove(
                objectToFormData({
                  id: expenseSelectedData,
                  approved_amount: amountValue,
                }),
              ),
            )
          }
        >
          Confirm
        </Button>
        <Button
          key="2"
          className="cancelButton ml1 mt1"
          onClick={() => handleCancel()}
        >
          Cancel
        </Button>
      </>
    );
  };

  return (
    <div className="expenses-table">
      <Modal
        title={
          modalType === "deleteExp"
            ? "Unlink Expense"
            : modalType === "delete"
              ? "Reject Expense"
              : "Partial Approve Expense"
        }
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={[]}
        className="center-aligned-modal"
      >
        {modalType === "deleteExp"
          ? renderDelete()
          : modalType === "delete"
            ? renderDeleteOption()
            : renderPartialAcceptOption()}
      </Modal>
      <Modal
        title={"Reciepts"}
        visible={filesPopup}
        onCancel={() => setFilesPopup(false)}
        footer={[]}
        className="right-alinged-modal popup-imgs"
      >
        {billFiles?.map((img) => (
          <img src={img.file} alt="" className={"w100 mb1"} />
        ))}
      </Modal>
      <TableWrap
        columns={columns}
        data={expensesData}
        pagination={false}
        handleRowClick={(evt, record) => {
          history.push({
            pathname: `/expense-details/${record.id}`,
            state: { expenseData: record },
          });
        }}
      />
    </div>
  );
};

export default Expenses;
